export * from "./lottie-animation-container";
export * from "./team-choice-header";

export type OnboardingContainerProps = {
    header: string;
    subheader: string;
    hideSubHeader?: boolean;
    hideFooterOnMobile?: boolean;
    PreHeader?: () => JSX.Element;
    fadeOutContent?: boolean;
    size?: "sm" | "lg";
};
